// extracted by mini-css-extract-plugin
module.exports = {"animateOnHover":"_d24a618","image":"_b3f8589"};